import { Icon } from '@chakra-ui/react';
import React from 'react';

export const ChevronIcon = ({ direction, ...props }) => {
  let rotation = '0';
  if (direction === 'up') {
    rotation = '90';
  } else if (direction === 'forward') {
    rotation = '180';
  } else if (direction === 'down') {
    rotation = '270';
  }

  return (
    <Icon xmlns="http://www.w3.org/2000/svg" data-name="Group 86983" viewBox="0 0 8 10.7" {...props}>
      <path
        style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
        transform={`rotate(${rotation})`}
        fill="currentColor"
        d="M6.6 10.5.3 5.9a.7.7 0 0 1 0-1.1L6.6.2c.6-.4 1.6 0 1.4.5-.5 1.5-1.6 1.7-1.6 4.7 0 2.8 1 3 1.6 4.6.2.5-.8 1-1.4.5z"
        data-name="Path 388576"
      />
    </Icon>
  );
};
